import { TextAreaBoxTasks } from './TextAreaBoxTasks';

export default TextAreaBoxTasks;
